﻿// This extension is to overwrite the focusInvalid function in the jquery.validate.js.
// When submitting the form, if there are invalid inputs, the focusInvalid will be called.
// The focusInvalid in jquery.validate.js gets the first element in error list and then triggers the focusin function.
// But if the first element isn't visible, the focusin function won't be triggered and this will cause an accessibility bug.
// This extension fixes it by finding the first visible error and focusing on it.
$.extend($.validator.prototype, {
    focusInvalid: function () {
        if (this.settings.focusInvalid) {
            try {
                var firstError = null;
                $.each(this.errorList, function (index, item) {
                    if ($(item.element).filter(":visible").length != 0) {
                        firstError = item.element;
                        return false;
                    }
                })

                $(this.findLastActive() || firstError || [])
                    .filter(":visible")
                    .focus()
                    // manually trigger focusin event; without it, focusin handler isn't called, findLastActive won't have anything to find
                    .trigger("focusin");
            } catch (e) {
                // ignore IE throwing errors when focusing hidden elements
            }
        }
    }
})